import { render } from "./Stoppage.vue?vue&type=template&id=4bf716a8&scoped=true"
import script from "./Stoppage.vue?vue&type=script&lang=js"
export * from "./Stoppage.vue?vue&type=script&lang=js"

import "./Stoppage.vue?vue&type=style&index=0&id=4bf716a8&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf716a8"]])

export default __exports__